import { render } from "./chef-review-table.vue?vue&type=template&id=39dd7dd6&scoped=true"
import script from "./chef-review-table.vue?vue&type=script&lang=js"
export * from "./chef-review-table.vue?vue&type=script&lang=js"

import "./chef-review-table.vue?vue&type=style&index=0&id=39dd7dd6&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39dd7dd6"]])

export default __exports__